<template>
  <!-- Footer-->
  <footer class="bg-dark py-4 mt-auto">
    <div class="container px-5">
      <div class="row align-items-center justify-content-between flex-column flex-sm-row">
        <div class="col-auto"><div class="small m-0 text-white">Copyright &copy; DJ Medi 2024</div></div>
        <div class="col-auto">
          <a class="link-light small" target="_blank" href="http://event-hochzeit-djmedi.de/pdf/impressum.pdf">Impressum</a>
          <span class="text-white mx-1">&middot;</span>
          <a class="link-light small" target="_blank" href="http://event-hochzeit-djmedi.de/pdf/datenschutz.pdf">Datenschutz</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
</style>